import { Category } from '@/types'
import i18next from 'i18next'

// use colors from tailwindcss
export const CATEGORIES: Record<string, Category> = {
  ROLEPLAY: {
    category: () => i18next.t('models.categories.roleplay.name'),
    description: () => i18next.t('models.categories.roleplay.description'),
    color: 'pink'
  },
  PROGRAMMING: {
    category: () => i18next.t('models.categories.programming.name'),
    description: () => i18next.t('models.categories.programming.description'),
    color: 'indigo'
  },
  PROGRAMMING_SCRIPTING: {
    category: () => i18next.t('models.categories.programming_scripting.name'),
    description: () => i18next.t('models.categories.programming_scripting.description'),
    color: 'amber'
  },
  MARKETING: {
    category: () => i18next.t('models.categories.marketing.name'),
    description: () => i18next.t('models.categories.marketing.description'),
    color: 'yellow'
  },
  MARKETING_SEO: {
    category: () => i18next.t('models.categories.marketing_seo.name'),
    description: () => i18next.t('models.categories.marketing_seo.description'),
    color: 'lime'
  },
  TECHNOLOGY: {
    category: () => i18next.t('models.categories.technology.name'),
    description: () => i18next.t('models.categories.technology.description'),
    color: 'green'
  },
  TECHNOLOGY_WEB: {
    category: () => i18next.t('models.categories.technology_web.name'),
    description: () => i18next.t('models.categories.technology_web.description'),
    color: 'emerald'
  },
  SCIENCE: {
    category: () => i18next.t('models.categories.science.name'),
    description: () => i18next.t('models.categories.science.description'),
    color: 'teal'
  },
  TRANSLATION: {
    category: () => i18next.t('models.categories.translation.name'),
    description: () => i18next.t('models.categories.translation.description'),
    color: 'cyan'
  },
  LEGAL: {
    category: () => i18next.t('models.categories.legal.name'),
    description: () => i18next.t('models.categories.legal.description'),
    color: 'sky'
  },
  FINANCE: {
    category: () => i18next.t('models.categories.finance.name'),
    description: () => i18next.t('models.categories.finance.description'),
    color: 'blue'
  },
  HEALTH: {
    category: () => i18next.t('models.categories.health.name'),
    description: () => i18next.t('models.categories.health.description'),
    color: 'indigo'
  },
  TRIVIA: {
    category: () => i18next.t('models.categories.trivia.name'),
    description: () => i18next.t('models.categories.trivia.description'),
    color: 'violet'
  },
  ACADEMIA: {
    category: () => i18next.t('models.categories.academia.name'),
    description: () => i18next.t('models.categories.academia.description'),
    color: 'purple'
  },
  REASONING: {
    category: () => i18next.t('models.categories.reasoning.name'),
    description: () => i18next.t('models.categories.reasoning.description'),
    color: 'fuchsia'
  },
  RESEARCH: {
    category: () => i18next.t('models.categories.research.name'),
    description: () => i18next.t('models.categories.research.description'),
    color: 'orange'
  },
  CREATIVE: {
    category: () => i18next.t('models.categories.creative.name'),
    description: () => i18next.t('models.categories.creative.description'),
    color: 'rose'
  },
  IMAGE_GENERATION: {
    category: () => i18next.t('models.categories.image_generation.name'),
    description: () => i18next.t('models.categories.image_generation.description'),
    color: 'violet'
  },
  MULTIMODAL: {
    category: () => i18next.t('models.categories.multimodal.name'),
    description: () => i18next.t('models.categories.multimodal.description'),
    color: 'cyan'
  }
}
